const apiUrl = 'https://api.3392.cn/'
const socket = new WebSocket('ws://api.3392.cn:8088')
export { apiUrl }
export { socket }


// WEBPACK FOOTER //
// ./src/apiUrl.js